import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EndasureService } from 'src/app/services/feature/Endasure/endasure.service';

@Component({
    selector: 'app-endasure-fleet-info',
    templateUrl: './endasure-fleet-info.component.html',
    styleUrls: ['./endasure-fleet-info.component.scss'],
    standalone: false
})
export class EndasureFleetInfoComponent {
  private readonly destroy$ = new Subject<void>();
  constructor(private readonly endasureService:EndasureService,private readonly cdr:ChangeDetectorRef){}

  ngOnInit() {
    this.endasureService.fleetInfoData$.pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      if(data!=null){
        this.fleetInfoForm.patchValue({
          fleetSizeTractors: data.fleetSizeTractors || 1000,
          tractorTradeInCycle: data.tractorTradeInCycle || 5,
          fleetSizeTrailers: data.fleetSizeTrailers || 1000,
          trailerTradeInCycle: data.trailerTradeInCycle || 10,
        });
      }
   
    })
    
  }

  fleetInfoForm = new FormGroup({
    fleetSizeTractors: new FormControl(1000,{ validators: Validators.required }),
    tractorTradeInCycle: new FormControl(5, { validators: Validators.required }),
    fleetSizeTrailers: new FormControl(1000, { validators: Validators.required }),
    trailerTradeInCycle: new FormControl(10, { validators: Validators.required }),   
  });

 
  get form() {
    return this.fleetInfoForm.controls;
  }
  endaSureNxt(){    
    if(this.fleetInfoForm.valid){
      this.endasureService.fleetInfoData$.next(this.fleetInfoForm.value);
     this.endasureService.currentComponent$.next('replacementCost');      
    }
    else{
      this.fleetInfoForm.markAllAsTouched();
    }  
    this.cdr.detectChanges();   
  }
  endaSureBack(){
    if(this.fleetInfoForm.valid){
      this.endasureService.currentComponent$.next('visitorInfo');    
    }
    else{
      this.fleetInfoForm.markAllAsTouched();
    }   
    this.cdr.detectChanges();    
  }


  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
